import { render, staticRenderFns } from "./GUIde.vue?vue&type=template&id=36949424&scoped=true&"
import script from "./GUIde.vue?vue&type=script&lang=js&"
export * from "./GUIde.vue?vue&type=script&lang=js&"
import style0 from "./GUIde.vue?vue&type=style&index=0&id=36949424&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36949424",
  null
  
)

export default component.exports